import top_cloud from '../../../assets/images/graphic-cloud-2.svg';
import bottom_cloud from '../../../assets/images/graphic-cloud-1.svg';
import star from '../../../assets/images/graphic-star.svg';
import icon_epic from '../../../assets/images/icon-epic-01.svg';
import epic from '../../../assets/images/epic-style-gaming.png';

import icon_st_kilda from '../../../assets/images/icon-st-kilda-01.svg';
import icon_port_phillip from '../../../assets/images/icon-port-phillip-01.svg';

import styled from 'styled-components';

export const Wrapper = styled.div`
padding-top: 3rem;
margin-bottom: 3rem;
width: 100%;
max-width: 1640px;

  .locations-layout {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    row-gap: 0.5rem;
  }

  .st-kilda-item, .port-melbourne-item {
    position: relative;
  }

  @media (min-width: 992px) {
    .locations-layout {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr;
      column-gap: 0.5rem;
    }
  }

  .clear-header {
    display: inline-block;
    width: 90%;
    max-width: 90%;
    height: 100px;
  }
  .blue-body {
    border: 8px solid var(--black);
    background-color: var(--nighttime);
    border-radius: var(--fat-border-radius);
    position: relative;
    display: inline-block;
    width: 90%;
    max-width: 90%;
    min-height: 490px;
    padding-top: 3rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .circle-icon {
    position: absolute;
    border: 8px solid var(--black);
    background-color: var(--accent1);
    border-radius: 50%;
    width: 160px;
    height: 160px;
    top: -90px;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 12;
  }
  .top-cloud {
    position: absolute;
    width: 160px;
    height: 80px;
    top: -8px;
    right: -8px;
    z-index: 10;
  }
  .bottom-cloud {
    position: absolute;
    width: 160px;
    height: 80px;
    bottom: -16px;
    left: -8px;
    z-index: 10;
  }
  .left-star-1 {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 50px;
    left: 10px;
    z-index: 10;
  }
  .left-star-2 {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 10px;
    left: 50px;
    z-index: 10;
  }
  .right-star {
    position: absolute;
    width: 50px;
    height: 50px;
    top: -28px;
    right: 25px;
    z-index: 10;
  }


  .pilars-item-epic {
    position: relative;
    background-image: url('${epic}');
    background-position: center; background-size: cover;
  }
  .icon-item-epic {
    background-image: url('${icon_epic}');
  }

  .epic-blue-body {
    border: 8px solid var(--black);
    background-color: var(--nighttime);
    border-radius: var(--fat-border-radius);
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: 100%;
    min-height: 500px;
    padding-top: 2rem;
    margin-top: 1rem;
    margin-bottom: 3rem;
  }


  .epic-locations-layout {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 0.3fr;
    row-gap: 0.5rem;
  }
  .hr-divider {
    display: none;
  }

  @media (min-width: 992px) {
    .epic-locations-layout {
      display: grid;
      grid-template-columns: 10fr 1fr 10fr;
      grid-template-rows: 1fr 0.2fr;
      column-gap: 0.5rem;
    }
    .hr-divider {
      display: block;
    }
    .vertical-hr {
      margin-top: 200px;
      width: 1px;
      height: 200px;
      border: 1px solid #fff;
    }

  }


  .epic-left-panel {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .epic-right-panel {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .epic-left-panel p, .epic-right-panel p {
    font: 18px/28px var(--body-font);
  }
 
  .epic-bottom-panel {
    padding-left: 1rem;
    padding-right: 1rem;

  }
  @media (min-width: 992px) {
    .epic-bottom-panel {
      grid-column: 1 / 4;
    }
    
  }

`

export const About = () => {

  return (
    <Wrapper>
      <div className='lr-padded-container center-text'>
        <h1 style={{marginBottom: '25px'}}>what's on</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
      </div>

      <div className='lr-padded-container center-text'>
        <p>Over two days in April, we will be celebrating local tabletop gaming alongside a Makers Market and fun activities for all ages.</p>
      </div>

      <div className='lr-padded-container locations-layout'>
        <div className='st-kilda-item'>
          <div className='clear-header'></div>
          <div className='blue-body center-text'>
            <h3 className='text-orange' style={{paddingTop:'3rem'}}>st kilda town hall</h3>
            <div style={{width:'80%', textAlign: 'left', paddingLeft: '3rem'}}>
              <p>The St Kilda Town Hall will host a wide range of tabletop gaming and creative activities for players of all ages, including:</p>
              <ul>
                <li>Locally developed tabletop games to learn and play with their creators</li>
                <li>Group and party games</li>
                <li>Makers Market</li>
                <li>Workshops and presentations</li>
              </ul>
              <p>More event announcements coming soon.</p>
            </div>
            {/* <a href="to.the.map" className='btn-pink' style={{margin: '0 auto', maxWidth: '170px'}}>map (pdf)</a> */}
            <div className='circle-icon'><img src={icon_st_kilda} alt='st kilda' width='110px' height='110px' style={{paddingTop:'25px'}} /></div>
            <div className='top-cloud'><img src={top_cloud} alt='cloud' /></div>
            <div className='bottom-cloud'><img src={bottom_cloud} alt='cloud' /></div>
          </div>
        </div>
        <div className='port-melbourne-item'>
          <div className='clear-header'></div>
          <div className='blue-body center-text'>
            <h3 className='text-orange' style={{paddingTop:'3rem'}}>st kilda library</h3>
            <div style={{width:'80%', textAlign: 'left', paddingLeft: '3rem', paddingRight: '2rem'}}>
              <p>Located across from the Town Hall, the St Kilda Library will be focused on games and activities for children aged 8–14 years, including:</p>
              <ul>
                <li>D&D 4 Kids</li>
                <li>Other Locally Made Kids Games</li>
              </ul>
              <p>More event announcements coming soon.</p>
            </div>
            <div className='circle-icon'><img src={icon_port_phillip} alt='st kilda library' width='110px' height='110px' style={{paddingTop:'25px'}} /></div>
            <div className='left-star-1'><img src={star} alt='star' /></div>
            <div className='left-star-2'><img src={star} alt='star' /></div>
            <div className='right-star'><img src={star} alt='star' /></div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}